import axios from "axios";
import { BASE_URL } from "../ultilitarios/system";

export function getTransacao(id: string) {
  return axios.get(`${BASE_URL}/pluggy/transactions/${id}`);
}
